import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import {
  Container,
  Stack,
  Step,
  StepLabel,
  Stepper,
  useMediaQuery,
} from "@mui/material";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import Check from "@mui/icons-material/Check";

import ValidateCUIL from "../../components/signup/validate-cuil";
import PersonalData from "../../components/signup/personal-data";
import GuestCourseStep from "../../components/signup/guest-course-step";
import Completion from "../../components/signup/completion";

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#white",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.success.alternative,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#white",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "gray",
  display: "flex",
  height: 22,
  alignItems: "center",
  ...(ownerState.active && {
    color: theme.palette.primary,
  }),
  "& .QontoStepIcon-completedIcon": {
    color: theme.palette.success.alternative,
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
}));

const QontoStepIcon = (props) => {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
};

const GuestSignUpPage = () => {
  const { state } = useLocation();
  const [currentStep, setCurrentStep] = useState(0);
  const [cuil, setCuil] = useState(null);
  
  // Local state to manage the inner steps of step 0 (CUIL vs Form)
  const [innerStep, setInnerStep] = useState(0);

  useEffect(() => {
    if (state !== null && state.cuil) {
      setCuil(state.cuil);
      setInnerStep(1);
    }
  }, [state]);

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const steps = [
    { key: 0, label: "Datos Personales" },
    { key: 1, label: "Código de acceso y curso" },
    { key: 2, label: "Finalizar" },
  ];

  const CustomizedSteppers = () => (
    <Stack sx={{ width: "100%" }} spacing={4}>
      <Stepper
        alternativeLabel
        activeStep={currentStep}
        connector={<QontoConnector />}
      >
        {steps.map((x) => (
          <Step key={x.key}>
            <StepLabel
              sx={{ color: "#ffff" }}
              StepIconComponent={QontoStepIcon}
            />
          </Step>
        ))}
      </Stepper>
    </Stack>
  );

  // Wrapper handlers to translate the inner 0 and 1 steps of the normal flow 
  // into just step 0 of our Guest flow
  const handleValidateCuilNext = (nextStep) => {
    // ValidateCUIL sets step to 1
    setInnerStep(1);
  };

  const handlePersonalDataNext = (nextStep) => {
    // PersonalData sets step to 2, we intercept it to advance our main step
    if (nextStep < innerStep) {
      // User clicked "Volver" in PersonalData
      setInnerStep(0);
    } else {
      // User clicked "Continuar"
      setCurrentStep(1);
    }
  };

  const handleGuestCourseNext = (nextStep) => {
    if (nextStep < currentStep) {
       // "Volver"
       setCurrentStep(0);
       setInnerStep(1); // Go back to Personal Data, not CUIL
    } else {
       setCurrentStep(2);
    }
  };

  return (
    <Container
      {...(isMobile ? { maxWidth: "xs" } : { fixed: true })}
      sx={{
        margin: isMobile ? 0 : undefined,
        padding: isMobile ? 0 : undefined,
      }}
    >
      <CustomizedSteppers />
      
      {currentStep === 0 && innerStep === 0 && (
        <ValidateCUIL
          currentStep={0}
          setCurrentStep={handleValidateCuilNext}
          setCuil={setCuil}
          isMobile={isMobile}
        />
      )}
      
      {currentStep === 0 && innerStep === 1 && (
        <PersonalData
          currentStep={1}
          setCurrentStep={handlePersonalDataNext}
          cuil={cuil}
          isMobile={isMobile}
          returnToStudents={false}
          isGuest={true}
        />
      )}
      
      {currentStep === 1 && (
        <GuestCourseStep
          currentStep={1}
          setCurrentStep={handleGuestCourseNext}
          isMobile={isMobile}
        />
      )}
      
      {currentStep === 2 && (
        <Completion
          currentStep={2}
          setCurrentStep={setCurrentStep}
          isMobile={isMobile}
          isGuest={true}
        />
      )}
    </Container>
  );
};

export default GuestSignUpPage;
